export const WORDS = [
  'kisses',
  'moosie',
  'pototo',
  'lottle',
  'liuliu',
  'totpie',
  'slothy',
  'cuties',
  'sbubby',
  'cuddle',
  'cawwot',
  'noodle',
  'pandey',
  'teethy',
  'doodoo',
  'fododo',
  'schnog',
  'adorbs',
  'trashy',
  'wordlu',
  'octipi',
  'bununa',
  'banana',
  'aminal',
  'veggie',
  'yumyum',
  'bunbun',
  'hotdog',
  'apples',
  'gaymes',
  'tumtum',
  'medley',
  'zoomie',
]

// Use to shuffle list when adding new words
// const shuffle = (a: any[]) => a.sort(() => Math.random() - 0.5)
